import { useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, UserPlus } from "lucide-react";

export default function AuthGateSheet({ isOpen, onClose, action, onLogin }) {
  const actionLabels = {
    claim: "claim this birthday deal",
    follow: "follow this truck",
    earn: "earn points",
    spot: "submit a truck spot",
    wait_time: "submit a wait time",
    punch: "scan your punch card",
  };

  const label = actionLabels[action] || "use this feature";

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-[9990]"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 z-[9991] bg-[#1C1C1E] rounded-t-2xl p-6 pb-8"
            data-testid="auth-gate-sheet"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 min-w-[44px] min-h-[44px] flex items-center justify-center text-white/50 hover:text-white"
              data-testid="auth-gate-close"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex flex-col items-center gap-4 text-center">
              <div className="w-14 h-14 rounded-full bg-amber-500/20 flex items-center justify-center">
                <UserPlus className="w-7 h-7 text-amber-400" />
              </div>
              <h3 className="text-lg font-semibold text-white">
                Create a free account to {label}
              </h3>
              <p className="text-sm text-white/60">
                It takes 30 seconds. Your action will complete automatically after signup.
              </p>
              <button
                onClick={onLogin}
                className="w-full py-3.5 bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-xl transition-colors text-base"
                data-testid="auth-gate-signup-btn"
              >
                Sign Up Free
              </button>
              <button
                onClick={onLogin}
                className="text-sm text-amber-400 hover:text-amber-300"
                data-testid="auth-gate-login-btn"
              >
                Already have an account? Log in
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
